var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.44988 35.0001H32.5499C35.1165 35.0001 36.7165 32.2168 35.4332 30.0001L22.8832 8.3168C21.5999 6.10013 18.3999 6.10013 17.1165 8.3168L4.56654 30.0001C3.28321 32.2168 4.88321 35.0001 7.44988 35.0001ZM19.9999 23.3335C19.0832 23.3335 18.3332 22.5835 18.3332 21.6668V16.6668C18.3332 15.7501 19.0832 15.0001 19.9999 15.0001C20.9165 15.0001 21.6665 15.7501 21.6665 16.6668V21.6668C21.6665 22.5835 20.9165 23.3335 19.9999 23.3335ZM21.6665 30.0001H18.3332V26.6668H21.6665V30.0001Z",
    fill: "#EFB035"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.5dd20e29693d05d24c9759e5a64d6922.svg";
export { ForwardRef as ReactComponent };